import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "react-bootstrap";
import { FaDesktop, FaMobileAlt, FaExternalLinkAlt, FaHome } from "react-icons/fa";

import { getThemeName, getThemeDocsAdminUrl, getThemeDocsAppUrl, getThemeLandingPageUrl } from "config/ConfigUtils";
import "./HelpDropdown.css";

const HelpDropdown = () => {
  const { t } = useTranslation();

  return (
    <Dropdown className="help-dropdown" align="end">
      <Dropdown.Toggle variant="success" id="dropdown-help" className="help-dropdown-toggle">
        {t("documents")}
      </Dropdown.Toggle>
      <Dropdown.Menu className="help-dropdown-menu">
        <Dropdown.Item
          as="a"
          href={getThemeDocsAdminUrl() || "https://dokuman.servistesin.com"}
          target="_blank"
          rel="noopener noreferrer"
          className="help-dropdown-item"
        >
          <FaDesktop className="help-dropdown-icon" />
          <div className="help-dropdown-content">
            <div className="help-dropdown-title">{t("websiteDocumentation")}</div>
            <div className="help-dropdown-desc">{t("websiteDocumentationDesc")}</div>
          </div>
          <FaExternalLinkAlt className="help-dropdown-external" />
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          href={getThemeDocsAppUrl() || "https://dokuman.servistesin.com"}
          target="_blank"
          rel="noopener noreferrer"
          className="help-dropdown-item"
        >
          <FaMobileAlt className="help-dropdown-icon" />
          <div className="help-dropdown-content">
            <div className="help-dropdown-title">{t("mobileAppDocumentation")}</div>
            <div className="help-dropdown-desc">{t("mobileAppDocumentationDesc")}</div>
          </div>
          <FaExternalLinkAlt className="help-dropdown-external" />
        </Dropdown.Item>
        <Dropdown.Item
          as="a"
          href={getThemeLandingPageUrl()}
          target="_blank"
          rel="noopener noreferrer"
          className="help-dropdown-item"
        >
          <FaHome className="help-dropdown-icon" />
          <div className="help-dropdown-content">
            <div className="help-dropdown-title">{t("landingPage", { brand: getThemeName() })}</div>
            <div className="help-dropdown-desc">{t("landingPageDesc")}</div>
          </div>
          <FaExternalLinkAlt className="help-dropdown-external" />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default HelpDropdown;
